namespace $ {
	export var $mol_crypto_native = $node.crypto.webcrypto as any as Crypto
}
